'use client';

import React, { useCallback } from 'react';
import { createMatchplayColumns } from './columns/matchplay-columns';
import { useIsMinimumTablet } from '@spikemark/shared-hooks';
import { TableRowOptions } from '../types';
import { MatchplayLeaderboardItem, TieWinner } from '../../../types/leaderboard';
import { Table } from '../table';
export type MatchplayLeaderboardProps = {
  leaderboard: MatchplayLeaderboardItem[];
  tournamentId: string;
  isAdmin?: boolean;
  winner?: TieWinner;
  onWinnerSelect?: (value: TieWinner) => void;
  playerRankingsDisplayCutoff?: number;
  teamRankingsDisplayCutoff?: number;
};
export const MatchplayLeaderboard: React.FC<MatchplayLeaderboardProps> = ({
  leaderboard,
  tournamentId,
  isAdmin,
  winner,
  onWinnerSelect,
  playerRankingsDisplayCutoff,
  teamRankingsDisplayCutoff
}) => {
  const isMinimumTablet = useIsMinimumTablet();
  const mobile = !isMinimumTablet;
  const columns = createMatchplayColumns(mobile, {
    isAdmin,
    winner,
    onWinnerSelect,
    teamRankingsDisplayCutoff,
    playerRankingsDisplayCutoff
  });
  const getExpandedRowData = useCallback(({
    rowData
  }: TableRowOptions<MatchplayLeaderboardItem>): Promise<MatchplayLeaderboardItem[]> => fetch(`/api/tournaments/${tournamentId}/matchplay/players?schoolLogo=${rowData.schoolLogo}&teamId=${rowData.id}`).then(res => res.json()), [tournamentId]);
  return <div className="flex flex-col" data-sentry-component="MatchplayLeaderboard" data-sentry-source-file="matchplay-leaderboard.tsx">
      <div>
        {leaderboard ? <Table<MatchplayLeaderboardItem> data={leaderboard} columns={columns} headerClassName="thead-secondary" expandable={!isAdmin} expandableData={getExpandedRowData} stickyHeader stickyTopClassName="top-header-mobile lg:top-header" stickyLeftClassName="left-0 lg:left-unset" allowHorizontalScroll rowClassName="bg-white" rowKey={({
        rowData
      }) => rowData.id} /> : null}
      </div>
    </div>;
};